"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessResponseSchema = void 0;
const zod_1 = require("zod");
// Schema-first (type inferred via `z.infer` below) — see the comment on
// `OrganizationUserDtoSchema` in ./organization for why.
exports.SuccessResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
//# sourceMappingURL=shared-response.js.map